module.exports = __webpack_public_path__ + "img/secondary-hero.e0c2261b.svg";